import { useCallback } from "react";
import { getAuth } from "firebase/auth";
import history from "infra/helpers/history";
import { useCurrentAuth } from "../auth.store";
import { useCurrentTenant } from "../tenant.store";
import { trackEvent } from "infra/helpers/event";

const auth = getAuth();

export default function useLogout() {
  const { reset: resetAuth } = useCurrentAuth();
  const { reset: resetTenant } = useCurrentTenant();

  const handleLogout = useCallback(async () => {
    const email = auth.currentUser?.email;
    const provider = auth.currentUser?.providerData[0].providerId;

    await auth.signOut();

    resetAuth();
    resetTenant();

    trackEvent("LogoutSucesso", {
      email,
      provider,
    });

    history.push("/auth/login");
  }, [resetAuth, resetTenant]);

  return {
    handleLogout,
  };
}
